export default __webpack_public_path__ + "static/integrations.url-d9808bef8fce4a2cd3d1dc30f6a9fbfc.svg";